function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo14PxRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14 14",
    style: {
      enableBackground: "new 0 0 14 14"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D93646"
    },
    d: "M7,0C3.1,0,0,3.1,0,7c0,3.9,3.1,7,7,7s7-3.1,7-7C14,3.1,10.9,0,7,0z M7,13c-3.3,0-6-2.7-6-6 s2.7-6,6-6s6,2.7,6,6S10.3,13,7,13z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D93646"
    },
    cx: 7,
    cy: 4,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D93646"
    },
    d: "M7,6C6.6,6,6.2,6.3,6.2,6.8v3.5C6.2,10.7,6.6,11,7,11s0.8-0.3,0.8-0.8V6.8C7.8,6.3,7.4,6,7,6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo14PxRed);
export default __webpack_public_path__ + "static/media/info-14px_red.6b179d87b3796efd9c4156260130fe2e.svg";
export { ForwardRef as ReactComponent };